import React from 'react'
import { Field, getFormValues, change } from 'redux-form'
import { connect } from 'react-redux'

import {FileRow} from './FileRow'
import FieldInput, { InputType as type } from 'components/SemanticForm'
import { listAttachment } from '../../data'
import { ProcurementBody } from 'routes/ProcurementSystem/styled'
import { 
  StdCard,
  FileUploadCell
} from 'components'

import { 
  AttachmentFormContainer,
  AttachmentInfoContainer
} from '../styled'
import r from 'reactotron-react-js'

const ContactAttachment = (props) => {

  const {
    valueForm,
    // props
    isEdit=false,
    isCreate=false,
    isDetail=false
  } = props

  const setAttachment = () => {
    if(valueForm.attachments){
      return listAttachment.map((x)=>{
        let items = valueForm.attachments.filter(x1 => x1.documentType.toLowerCase() === x.name)
        return <FileRow attachmentTitle={x.label} files={items} />
      })
    }else{
      return null
    }
  }

  if(valueForm){
    var countAttachLine = null
    countAttachLine = Array(Math.ceil(listAttachment.length / 3)).fill(1)
  }

  return (
    <ProcurementBody>
      <StdCard title='Attactment' style={{ marginTop: '10px' }}>
        {isDetail?
        <AttachmentInfoContainer>
          {valueForm&&valueForm.attachments&&setAttachment()}
        </AttachmentInfoContainer>
        :
        <React.Fragment>
          {countAttachLine&&countAttachLine.map((v, i1) => {
            return (
              <AttachmentFormContainer>
                {listAttachment.map((a,i2) => {
                  if (Math.floor(i2 / 3) === i1) {
                    return (
                      <div key={i2} style={{width: '31%',display: 'flex',flexDirection: 'column',marginRight: '1rem',}}>
                        <Field 
                          name={a.name} 
                          label={a.label}
                          require={a.require}
                          type={type.file}
                          component={FieldInput}
                          limitFileSize={80}
                        />
                        <div style={{ flex: 1 }}>
                          {valueForm.attachments
                            ? valueForm.attachments.filter( x => x.documentType.toLowerCase() === a.name.toLowerCase() && !x.deleted ).map((item, i3) => (
                                  <span className='oldFile'><FileUploadCell
                                    key={`${item.originalFilename}${i3}`}
                                    fileName={item.originalFilename}
                                    fileSize={item.size}
                                    deleted={item.deleted}
                                    urlPath={item.urlPath}
                                    onClickDelete={() => {
                                      let index = valueForm.attachments.findIndex(x => x.id === item.id)
                                      props.dispatch(change('formContract',`attachments[${index}].deleted`,true))
                                    }}
                                  /></span>
                                ))
                            : null}
                        </div>
                      </div>
                    )
                  }else{
                    return null
                  }
                })}
              </AttachmentFormContainer>
            )})}
          </React.Fragment>
        }
      </StdCard>
    </ProcurementBody>
  )
}

const mapStateToProps = (state) => ({
  valueForm: getFormValues('formContract')(state),
})

const mapDispatchToProps = (dispatch) =>({
  dispatch
})

export default connect(mapStateToProps, mapDispatchToProps)(ContactAttachment)